
export class LodgeAmountDialogController {

    public amount: number;

    /** @ngInject */
    public constructor(public title: string, public max: number) {

    }
}
